import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TwitterCircleFilledSvg from "@ant-design/icons-svg/es/asn/TwitterCircleFilled";
import AntdIcon from "../components/AntdIcon";
var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TwitterCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TwitterCircleFilled.displayName = 'TwitterCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(TwitterCircleFilled);